export function flattenCategories<T extends { categories: T[] }>(array: T[]): T[] {
    const result: T[] = [];
    array.forEach(item => {
        result.push(item);
        if (item.categories?.length) {
            result.push(...flattenCategories(item.categories));
        }
    });
    return result;
}